(() => {
  const source = document.querySelector('cart-drawer .drawer-express');
  if (!source) return;

  const copyStyles = (root) => {
    if (root.querySelector('[data-ahf-style]')) return;
    document
      .querySelectorAll('link[href*="component-ahf-drawer-express"], #shopify-accelerated-checkout-styles')
      .forEach((node) => {
        const copy = node.cloneNode(true);
        copy.removeAttribute('id');
        copy.dataset.ahfStyle = '';
        root.append(copy);
      });
  };

  const place = (root) => {
    const form = root.querySelector('footer button[name="checkout"]')?.closest('form');
    if (form && form.nextElementSibling !== source) form.after(source);
  };

  const cartKey = (cart) => `${cart.item_count}:${cart.total_price}:${cart.items.map((item) => item.key).join(',')}`;
  let renderedKey = null;
  let refreshTimer;

  const refresh = async () => {
    try {
      const cart = await (await fetch('/cart.js')).json();
      const key = cartKey(cart);
      if (renderedKey === null) renderedKey = key;
      if (key === renderedKey || !cart.item_count) return;

      const html = await (await fetch('/cart?view=ahf-express')).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.drawer-express');
      if (!fresh) return;
      source.replaceChildren(...[...fresh.childNodes].map((node) => document.importNode(node, true)));
      renderedKey = key;
    } catch (error) {}
  };

  const scheduleRefresh = () => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 400);
  };

  const attach = () => {
    const root = document.getElementById('recharge-storefront-experiences__cart-drawer')?.shadowRoot;
    if (!root) return false;
    copyStyles(root);

    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        place(root);
        scheduleRefresh();
      });
    }).observe(root, { childList: true, subtree: true });

    place(root);
    return true;
  };

  refresh();
  if (attach()) return;
  const waiter = new MutationObserver(() => attach() && waiter.disconnect());
  waiter.observe(document.body, { childList: true, subtree: true });
})();
